import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';

// Initialize exporting module
exporting(Highcharts);

const ComparisonScheduledbar = () => {
  // Define your data
  const periods = ['Period 1', 'Period 2', 'Period 3', 'Period 4', 'Period 5'];
  const membersEnrolled = [50, 60, 70, 80, 90]; // Example data for scheduled calls
  const completedCalls = [40, 50, 60, 70, 80]; // Example data for completed calls

  const yAxisJson = {
    title: {
      text: ''
    }
  };

  const tooltipJson = {
    shared: true,
    valueSuffix: ' members'
  };

  const columnData = [{
    name: 'Scheduled Calls',
    data: membersEnrolled,
    color: '#1279be'
  }, {
    name: 'Completed Calls',
    data: completedCalls,
    color: '#f45b5b'
  }];

  const optionsCN3 = {
    chart: {
      type: 'column',
      height: 220,
      spacing: [0, 0, 0, 0],
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 15,
        depth: 50,
        viewDistance: 25 // Adjusted viewDistance for better 3D effect
      }
    },
    title: {
      text: null,
      align: 'left',
      style: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#333',
        fontFamily: "IBM Plex Sans, sans-serif"
      }
    },
    xAxis: {
      categories: periods,
      gridLineWidth: 0
    },
    yAxis: yAxisJson,
    tooltip: tooltipJson,
    plotOptions: {
      column: {
        borderRadius: 20, // Set border radius for columns
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          style: {
            textOutline: 'none'
          }
        }
      }
    },
    series: columnData,
    credits: {
      enabled: false
    },
    exporting: {
      enabled: true
    },
    legend: {
      enabled: true
    }
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={optionsCN3}
      />
    </div>
  );
};

export default ComparisonScheduledbar;
